<template>
  <el-form ref="form" :model="form" label-width="200px" class="elForm">
    <el-form-item label="技师姓名：" required="true">
      <el-input v-model="form.input" placeholder="" style="width: 600px"></el-input>
    </el-form-item>
    <el-form-item label="技师对应账号：" required="true">
      <el-autocomplete v-model="state" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" @select="handleSelect" style="width: 200px"></el-autocomplete>
    </el-form-item>
    <el-form-item label="服务区域：" required="true">
      <ul class="selectedArea">
        <li v-for="(item, index) in serviceAreaList" :key="index">
          <el-select v-model="form.region" placeholder="请选择省" style="width: 200px">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
          <el-select v-model="form.region" placeholder="请选择市" style="width: 200px">
            <el-option label="区域一" value="       hanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
          <el-select v-model="form.region" placeholder="请选择区" style="width: 200px">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
          <el-link v-if="index >= 1" type="primary" @click="delService(item.id)">删除</el-link>
        </li>
      </ul>
      <el-link type="primary" @click="addService">+服务区域</el-link>
    </el-form-item>
    <el-form-item label="服务分类：" required="true">
      <el-input v-model="form.name" placeholder="请填写手机号码" style="width: 600px"></el-input>
    </el-form-item>
    <el-form-item label="手机号码：" required="true">
      <el-input v-model="form.name" placeholder="请填写手机号码" style="width: 600px"></el-input>
    </el-form-item>
    <el-form-item label="所在地址：" required="true">
      <el-input v-model="form.name" placeholder="请填写所在地址"  style="width: 600px"></el-input>
    </el-form-item>
    <el-form-item label="职称：">
      <el-input v-model="form.name" placeholder="请填写职称"  style="width: 600px"></el-input>
    </el-form-item>
    <el-form-item label="从事维修年限：">
      <el-input v-model="form.name" placeholder="请填写从事维修年限"  style="width: 600px"></el-input>
    </el-form-item>
    <el-form-item class="centerBtn">
      <el-button type="primary" @click="onSubmit">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      // 技师对应账号
      restaurants: [],
      state: '',
      timeout: null,
      // 服务区域
      serviceAreaList: [{
        id: 1,
        name: "hh"
      }],
    };
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    mounted() {
      this.restaurants = this.loadAll();
    },
    // 远程搜索联想
    loadAll() {
      return [
        { value: '三全鲜食（北新泾店）', address: '长宁区新渔路144号' },
        { value: 'Hot honey 首尔炸鸡（仙霞路）', address: '上海市长宁区淞虹路661号' },
        { value: '新旺角茶餐厅', address: '上海市普陀区真北路988号创邑金沙谷6号楼113' },
        { value: '泷千家(天山西路店)', address: '天山西路438号' },
        { value: '胖仙女纸杯蛋糕（上海凌空店）', address: '上海市长宁区金钟路968号1幢18号楼一层商铺18-101' },
      ];
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return state => {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect(item) {
      console.log(item);
    },

    // 添加服务区域
    addService() {
      this.serviceAreaList.push({
        id: this.serviceAreaList.length+1,
        name: "jj"
      });
      console.log(this.serviceAreaList);
    },

    // 删除服务区域
    delService(id) {
      let index = this.serviceAreaList.findIndex(item => item.id == id);
      console.log(index);
      this.serviceAreaList.splice(index, 1);
    },
  },
};
</script>

<style lang="less" scoped>
span {
  color: gray;
}
.elForm {
  background-color: #fff;
  padding: 30px;
}

.centerBtn {
  display: flex;
  justify-content: center;
  align-items: center;
}

.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
.selectedArea {
  margin-bottom: 20px;
}
</style>
